const DEFAULT_RARITY_COLOR = '#4cc9f0';

function darken(hex: string, amount: number): string {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim());
  if (!m) return hex;
  const n = parseInt(m[1], 16);
  const f = Math.max(0, Math.min(1, 1 - amount));
  const r = Math.round(((n >> 16) & 0xff) * f);
  const g = Math.round(((n >> 8) & 0xff) * f);
  const b = Math.round((n & 0xff) * f);
  return `#${((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1)}`;
}

/**
 * Shared rarity gradient for ItemCard / ItemListItem / DrawCard.
 * Darkened toward black so the artwork on top stays readable.
 */
export function rarityGradient(color?: string | null): string {
  const c = color || DEFAULT_RARITY_COLOR;
  return `linear-gradient(150deg, ${darken(c, 0.25)} 0%, ${darken(c, 0.5)} 60%, ${darken(c, 0.7)} 100%)`;
}
